const MAX_SYMBOLS_QUANTITY = 140;

export { MAX_SYMBOLS_QUANTITY };
